import * as Yup from "yup";

export const memberMembershipSchema = Yup.object().shape({
    idTenant: Yup.string().required("O idTenant é obrigatório"),
    idSale: Yup.string().required("O id de venda é obrigatório"),
    idMember: Yup.string().required("Membro é obrigatório"),
    memberName: Yup.string().required("Nome do membro é obrigatório"),
    idMembership: Yup.string().required("Plano de origem é obrigatório"),
    membershipName: Yup.string().required("Nome do plano é obrigatório"),
    type: Yup.string().required("Tipo de plano é obrigatório"),
    durationType: Yup.string().required("Tipo de duração é obrigatória"),
    duration: Yup.number().required("Duração é obrigatória"),
    enrollmentRequired: Yup.boolean().default(false),
    memberXp: Yup.number().default(0),
    employeeXp: Yup.number().default(0),
    startDate: Yup.string().required("Data de início é obrigatória"),
    endDate: Yup.string().required("Data de término é obrigatória"),
    originalValue: Yup.number().required("Valor original do plano é obrigatório"),
    discount: Yup.number().default(0),
    price: Yup.number().required("Preço final é obrigatório"),
    isScholarship: Yup.boolean().default(false),
    status: Yup.string().oneOf(["active", "suspended", "canceled", "expired"]).default("active"),
    allowsSuspension: Yup.boolean().default(false),
    maxSuspensionDays: Yup.number().default(0),
    disponibleSuspensionDays: Yup.number().default(0),
    numberSuspensionTimes: Yup.number().default(0),
    suspensionFee: Yup.number().default(0),
    freezes: Yup.array().of(
        Yup.object().shape({
            startDate: Yup.string().required("Data de início da suspensão é obrigatória"),
            endDate: Yup.string().required("Data final da suspensão é obrigatória"),
            days: Yup.number().required("Quantidade de dias é obrigatória"),
            reason: Yup.string(),
            createdAt: Yup.string()
        })
    ).default([]),
    cancellationFee: Yup.number().default(0),
    cancellationNoticeDays: Yup.number().default(0),
    allowsCancellationByApp: Yup.boolean().default(false),
    cancelDate: Yup.string().nullable(),
    cancelReason: Yup.string()
});
